import { GlobalTag, ItemWithGlobalTags } from "@/types";

export function extractGlobalTags(items: ItemWithGlobalTags[]) {
  const tagMap = new Map<string, string>();
  items.forEach((item) => {
    item.globalTags?.forEach((tag) => {
      if (tag.label.toLowerCase() !== "hot topic") {
        tagMap.set(tag.id, tag.label);
      }
    });
  });
  return Array.from(tagMap.entries())
    .map(([id, label]) => ({ id, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
